class MQ {
    constructor() {
        this.breakpoints = {
            tiny: 370,
            before_mobile: 575,
            mobile: 576,
            before_large: 1024,
            large: 1025,
        };
    }

    isTiny() {
        return window.matchMedia(`(max-width: ${this.breakpoints.tiny}px)`).matches;
    }

    isMobile() {
        return window.matchMedia(`(max-width: ${this.breakpoints.before_mobile}px)`).matches;
    }

    isTablet() {
        return window.matchMedia(`(min-width: ${this.breakpoints.mobile}px)`).matches
            && window.matchMedia(`(max-width: ${this.breakpoints.before_large}px)`).matches;
    }

    isLarge() {
        return window.matchMedia(`(min-width: ${this.breakpoints.large}px)`).matches;
    }

    isPortrait() {
        return window.matchMedia('(orientation: portrait)').matches;
    }

    isLandscape() {
        return window.matchMedia('(orientation: landscape)').matches;
    }
}

export const MediaQuery = new MQ();



// WEBPACK FOOTER //
// ./app/media-query.js